import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; 


class GalleryImagev2 extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
          photoIndex: 0,
          isOpen: false,
          isEnd:true,
          galleryActiveIndex: 0
        };

        this._renderCustomControls = this._renderCustomControls.bind(this);
        this._onclickRightNav = this._onclickRightNav.bind(this);
        this._onclickLeftNav = this._onclickLeftNav.bind(this);
    }

    _renderCustomControls(){
      this.setState({ isOpen: !this.state.isOpen })
    }

    _onclickRightNav(){
      let galleryIndex = this.state.galleryActiveIndex + 1;
      this.setState({
        isEnd: (galleryIndex === 0 || (this.props.galleryImages.length-1 === galleryIndex)) ? true : false,
        galleryActiveIndex: galleryIndex,
        photoIndex: galleryIndex
      })
      
      if(galleryIndex>1 && (this.props.galleryImages.length-2 !== galleryIndex-1) ){
        this._imageGallery.setState({currentIndex: galleryIndex - 1})
      }
    }
    _onclickLeftNav(){
      let galleryIndex = this.state.galleryActiveIndex - 1;
      this.setState({
        isEnd: (galleryIndex === 0) ? true : false,
        galleryActiveIndex: galleryIndex,
        photoIndex: galleryIndex
      })
      if(galleryIndex>0){
        this._imageGallery.setState({currentIndex: galleryIndex - 1})
      }
    }
    
    render() {
      const { photoIndex, isOpen } = this.state;
      const { galleryImages } = this.props;
      return (
        <div>
          <ImageGallery 
              ref={i => this._imageGallery = i}
              items={galleryImages} 
              infinite={false} 
              showPlayButton={false} 
              useTranslate3D={false} 
              showFullscreenButton={false}
              slideDuration={1000}
              slideInterval={5000}
              additionalClass={(!this.state.isEnd) ? 'moved'  : (this.state.galleryActiveIndex-1 >= galleryImages.length-2 ? 'moved-end' : '' )}
              onThumbnailClick={ (event,index) => {
                  this.setState({
                    isEnd: (index === 0 || (this.props.galleryImages.length-1 === index)) ? true : false,
                    galleryActiveIndex: index,
                    photoIndex: index
                  })

                  if(index>1 && (this.props.galleryImages.length-2 !== (index-1)) ){
                    this._imageGallery.setState({currentIndex: (index - 1) })
                  }else if((index-1)===0){
                    this._imageGallery.setState({currentIndex: 0 })
                  }
              }}
              renderCustomControls={ (event,index) => {
                if(photoIndex < (galleryImages.length)) {
                  return <div className='image-gallery-custom-action' onClick={this._renderCustomControls.bind(this)}></div>
                }
              }}
              renderRightNav={(onClick, disabled) => {
                return (
                  <button
                    className='image-gallery-right-nav'
                    disabled={ ( this.state.galleryActiveIndex-1 >= galleryImages.length-2 ) ? true : null}
                    onClick={this._onclickRightNav.bind(this)}/>
                )
              }}
              renderLeftNav={(onClick, disabled) => {
                return (
                  <button
                    className='image-gallery-left-nav'
                    disabled={ (this.state.galleryActiveIndex === 0) ? true : null }
                    onClick={this._onclickLeftNav.bind(this)}/>
                )
              }}
              />
            {isOpen && (
              <Lightbox
                wrapperClassName={(!this.state.isEnd) ? 'moved'  : (this.state.galleryActiveIndex-1 >= galleryImages.length-2 ? 'moved-end' : '' )}
                mainSrc={galleryImages[photoIndex]['hd']}
                nextSrc={galleryImages[(photoIndex + 1) % galleryImages.length]['hd']}
                prevSrc={galleryImages[(photoIndex + galleryImages.length - 1) % galleryImages.length]['hd']}
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() => {
                  let prevIndex = ((photoIndex-1) + galleryImages.length) % galleryImages.length;
                  if(prevIndex < galleryImages.length - 1) {
                    this.setState({
                      isEnd: (prevIndex === 0) ? true : false,
                      galleryActiveIndex: prevIndex,
                      photoIndex: prevIndex
                    })
  
                    if(prevIndex > 0){
                      this._imageGallery.setState({currentIndex: prevIndex - 1 })
                    }
                  }
                }
                }
                onMoveNextRequest={() => {
                  let nextIndex = (photoIndex === (galleryImages.length -1)) ? 0 : (photoIndex + 1) % galleryImages.length;
                  if(nextIndex>0){

                    // this.setState({
                    //   photoIndex: nextIndex
                    // })
                    // this._imageGallery.setState({currentIndex: (windowWidth > 768) ? nextIndex - 1 : nextIndex })
                    // console.log(this.props.galleryImages.length-1 + "===" + nextIndex)
                    this.setState({
                      isEnd: (nextIndex === 0 || (this.props.galleryImages.length-1 === nextIndex)) ? true : false,
                      galleryActiveIndex: nextIndex,
                      photoIndex: nextIndex
                    })
                    if(nextIndex>1 && (this.props.galleryImages.length-2 !== nextIndex-1) ){
                      this._imageGallery.setState({currentIndex: nextIndex - 1})
                    }
                  }
                }
                }
              />
            )}
        </div>
      );
    }
  
  }

  export default GalleryImagev2;


// WEBPACK FOOTER //
// ./src/components/GalleryImagev2.js